import { type AnchorHTMLAttributes, forwardRef, type ReactNode } from 'react';

import { useNavigateShell } from '@/core/hooks/use-navigate-shell';

type ShellLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  to: string;
  children: ReactNode;
};

/**
 * In-shell link that uses Ionic navigation instead of react-router history.
 */
export const ShellLink = forwardRef<HTMLAnchorElement, ShellLinkProps>(
  function ShellLink({ to, onClick, children, className, ...rest }, ref) {
    const { navigateShell } = useNavigateShell();

    return (
      <a
        ref={ref}
        href={to}
        className={className}
        onClick={(event) => {
          if (
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            event.button !== 0
          ) {
            return;
          }

          event.preventDefault();
          navigateShell(to);
          onClick?.(event);
        }}
        {...rest}
      >
        {children}
      </a>
    );
  },
);
